<template>
  <router-link to="/basket" class="mob-link">
  <span class="float-right" v-if="$store.state.cartCount">{{$store.state.cartCount}}</span>
  </router-link>
</template>

<script>
export default {
    name:"shopping-cart",
}
</script>